<template>
  <modal
    :closeIcon="true"
    :show.sync="localDisplay"
    modal-classes="modal-dialog-centered modal-s"
    body-classes="p-0 m-0"
    header-classes="border-bottom"
  >
    <h4 slot="header" class="modal-title my-auto" id="exampleModalLabel">
      Apercu de la macro importée
    </h4>
    <div
      v-for="macro in selectedMacro"
      :key="macro.id"
      class="container-fluid py-4"
    >
      <p class="row ml-2 mx-0" style="font-size: 2rem">
        {{ macro.title }}
      </p>
      <h2 class="row ml-2">
        <img class="prefix" src="~/assets/zendesk-round.svg" />
        <p class="ml-1 my-auto">
          {{ macro.id }}
        </p>
      </h2>
      <div class="row ml-2 text-muted h5">
        <font-awesome-icon
          class="mr-2 my-auto"
          :icon="['fad', 'calendar-day']"
          style="cursor: pointer"
        ></font-awesome-icon>
        <p class="my-auto">Crée le: {{ macro.created_at }}</p>
      </div>
      <div class="row ml-2 text-muted h5">
        <font-awesome-icon
          class="mr-2 my-auto"
          :icon="['fad', 'calendar-day']"
          style="cursor: pointer"
        ></font-awesome-icon>
        <p class="my-auto">MAJ le: {{ macro.updated_at }}</p>
      </div>
      <div class="macro-action-modal-array container mt-4">
        <h3 class="ml-2">Actions de la macro</h3>
        <div class="ml-2" v-for="(action, idx) in macro.actions" :key="idx">
          <div class="row">
            <div class="col-5" style="">
              <p class="text-muted text-uppercase h5">
                {{ action.field }}
              </p>
            </div>
            <div
              class="col ml-2 h5 mb-0"
              style="
                border-left: 1px solid #adb5bd;
                max-height: 100px;
                overflow: hidden;
              "
            >
              <p style="overflow: hidden">
                {{ action.value }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'macro-editor-modal',
  props: {
    selectedMacro: Array,
    display: Boolean,
  },
  data() {
    return {
      localDisplay: this.display,
    };
  },
  watch: {
    localDisplay() {
      if (!this.localDisplay) this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.header-border {
  border-bottom: 1px solid $grey-5-mayday !important;
}

.macro-action-modal-array {
  padding: 8px;
  border-radius: 3px;
  background-color: $grey-1-mayday;
}
</style>
